import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import { btnGhost, btnPrimary } from '../components/ui';

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <SEO title={t('notFound.title')} description={t('notFound.body')} url="https://simpian.com/" />
      <section className="mx-auto max-w-xl px-4 py-24 text-center">
        <h1 className="font-display text-4xl">{t('notFound.title')}</h1>
        <p className="mt-4 text-muted">{t('notFound.body')}</p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link className={btnPrimary} to="/">{t('notFound.home')}</Link>
          <Link className={btnGhost} to="/products">{t('notFound.products')}</Link>
        </div>
      </section>
    </>
  );
};

export default NotFoundPage;
